/**
 * All Global site scripts required should be included here.
 *
 * This is the file that Webpack is compiling into front.[hash].js
 */

import '../../sass/style.scss'

var header = require('./modules/header.js'),
    algolia = require('./modules/algolia.js'),
    algolia_webinars = require('./modules/algolia_webinars.js'),
    algolia_vendors = require('./modules/algolia_vendors.js'),
    algolia_genre = require('./modules/algolia_genre.js'),
    search_companies = require('./modules/search_companies.js'),
    layout = require('./modules/layout.js'),
    toc = require('./modules/table_of_contents'),
    loadMore = require('./modules/loadMore'),
    grid = require('./modules/grid'),
    timeline = require('./modules/timeline'),
    acf_extension = require('./modules/acf_extension.js'),
    article = require('./modules/article'),
    feature = require('./modules/feature'),
    // interstitial = require('./modules/interstitial.js'),
    my_account = require('./modules/my_account.js'),
    ads = require('./modules/ads'),
    data_layer = require('./modules/data_layer.js'),
    checkout = require('./modules/checkout.js'),
    mobile_slide_menu = require('./modules/mobile_slide_menu.js'),
    featured_carousel = require('./modules/featured_carousel.js');

header();
algolia();
algolia_vendors();
algolia_genre();
algolia_webinars();
// search_companies();
layout();
my_account();
loadMore.init();
grid();
timeline.init();
acf_extension();
article.init();
feature.init();
// interstitial.init();
// ads.init();
data_layer();
checkout();
mobile_slide_menu.init();
featured_carousel();
